import React, { useState } from "react";
import { Button, Stack, styled, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SheetContainer } from "../../../../../styles/common";
import Help from "@shared/help";
import { AssociatedCustomerDataList } from "store/slices/validatePAN";

const DrawerBody = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ theme }) => theme.spacing(2)};
  row-gap: 6px;
  color: #333333;
`;

interface BankDiffAccProps {
  bankAction?: (actionType: "CONTINUE" | "RESET") => void;
}

function BankDiffAcc({ bankAction }: BankDiffAccProps) {
  const { t } = useTranslation();
  const info = useSelector((state: any) => state.info.allData);
  const bankValidation = useSelector((state: any) => state.bank);

  const [isHelpOpen, setIsHelpOpen] = useState<boolean>(false);
  return (
    <>
      <SheetContainer open={true} anchor="bottom">
        <DrawerBody>
          <Typography variant="h2">
            {t("bank_already_linked_message", {
              defaultValue:
                "This bank account is already linked to below Customer IDs:",
            })}
          </Typography>
          <table>
            {(
              (bankValidation?.bankResponse
                ?.associatedCustomerDataList as AssociatedCustomerDataList[]) ||
              []
            ).map((item) => (
              <tr key={item.customerId}>
                <td style={{ whiteSpace: "nowrap", verticalAlign: "top" }}>
                  <Typography color="primary">{"Customer ID: "}</Typography>
                </td>
                <td>
                  <Typography color="primary">
                    {`${item.customerId} (${item.shopName})`}
                  </Typography>
                </td>
              </tr>
            ))}
          </table>

          <Typography sx={{ pt: 1.5 }} color="#666666">
            <Trans
              i18nKey={"continue_same_bank_message"}
              values={{
                customerId: info?.customerId,
              }}
              components={{
                mark: (
                  <Typography
                    component={"span"}
                    color="#000000"
                    fontWeight={600}
                  />
                ),
              }}
            />
          </Typography>
          <Typography sx={{ pb: 2 }} color="primary">
            {`${t("firm_name", {
              defaultValue: "Firm Name",
            })}: ${info?.shopName}`}
            {}
          </Typography>
          <Stack spacing={2} width="100%">
            {/* <Button
              variant="contained"
              size="large"
              onClick={() => bankAction?.("CONTINUE")}
            >
              {t("use_same_bank_details", {
                defaultValue: "Use Same Bank Details",
              })}
            </Button> */}
            <Button
              variant="outlined"
              size="large"
              onClick={() => bankAction?.("RESET")}
            >
              {t("enter_different_bank_details", {
                defaultValue: "Enter Different Bank Details",
              })}
            </Button>
            <Button
              variant="text"
              size="large"
              onClick={() => setIsHelpOpen(true)}
            >
              {t("contact_support", { defaultValue: "Contact Support" })}
            </Button>
          </Stack>
        </DrawerBody>
      </SheetContainer>
      <Help open={isHelpOpen} close={setIsHelpOpen} />
    </>
  );
}

export default BankDiffAcc;
